export default "__VITE_ASSET__CE681xCC__"